import { render } from "./WelcomeHeader.vue?vue&type=template&id=0efbe2da&scoped=true"
import script from "./WelcomeHeader.vue?vue&type=script&lang=js"
export * from "./WelcomeHeader.vue?vue&type=script&lang=js"

import "./WelcomeHeader.vue?vue&type=style&index=0&id=0efbe2da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efbe2da"]])

export default __exports__